import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from "ramda"

import AnnouncementComponent from '../components/announcements/announcements.component';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { selectListItems } from '../../../../../redux/library/selector';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { selectOrganizationUnitsListItems } from '../../../../../redux/organizationUnits/selector';
import { deepCopy } from '../../../../../common/services/common.service';
import { organizationUnits } from '../../../../../redux/organizationUnits/action';
import PageLoader from '../../../../../components/PageLoader';

let currentChange: any = {}
const AnnouncementContainer = ({ onSubmit, cardDetailInfo }: any) => {
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const libraryData = useSelector(selectListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectedAnnouncement, setSelectedAnnouncement] = useState<any>({
    IsLimitedToRoute: false,
  })
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const organizationUnitsLists = useSelector(selectOrganizationUnitsListItems)
  const [
    announcementImageIndex,
    setAnnouncementImageIndex
  ] = useState<any>([])

  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);

  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }
  const handleInnerFormItemChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedAnnouncement({ ...selectedAnnouncement, [fields[0]]: value });
  }
  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedAnnouncement({ ...selectedAnnouncement, [field]: event })
  }

  useEffect(
    () => {
      dispatch(organizationUnits.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`, entity: 'organizationUnits', jsonData: {} }))
        .then(() => {
          if (cardDetailInfo) {
            setSelectedAnnouncement(cardDetailInfo)
            setIsLoading(false)
          } else {
            const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
            setMediaFiles(localSelectedMedia)
            setIsLoading(false)
          }
        }
        )
    },
    []
  )

  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      OwnerTypeId: 111,
      OwnerId: parmas?.id,
      FileTypeId: 0,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setMediaInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  // const changeImage = (idx: number, templateField: any, fileType: any) => {
  //   setAnnouncementImageIndex(idx)
  //   dispatch(settings.set({ getUploadFiles: 'open' }))
  //   setOpenFile({
  //     currentFileSrc: mediaFiles[idx][templateField],
  //     folder: 'Announcement',
  //     type: fileType
  //   })
  // }
  const handleSubmit = (data: any) => {

    mediaFiles[announcementImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  // useEffect(() => {

  //     if (isQuery) {
  //       setSelectedAnnouncement(announcementsQuery?.result?.items)
  //       const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: announcementsQuery?.result?.items?.MediaMappings?.MediaFiles });
  //       setMediaFiles(localSelectedMedia)
  //       }
  //   }, [isQuery]
  // ) 

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    const announcementData = {
      ...selectedAnnouncement,

    }
    onSubmit(announcementData)
  }

  // const back=()=>{
  //   navigate('/management/cms/announcements')
  // } 
  // const handleClose = () => {
  //   dispatch(settings.set({ getUploadFiles: 'close' }))

  // }

  // useEffect(
  //   () => {
  //     if (currentChange.field === 'FileTypeId') {
  //       setMediaInfo()
  //     }
  //   },
  //   [mediaFiles]
  // )


  return (
    <>
      {/* {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
     folder={openFile?.folder}
          handleClose={handleClose}
          handleFilesSubmit={handleSubmit}
          type={openFile?.type}
          ownerId={parmas?.id}
          />} */}
      {isLoading ? <PageLoader /> :
        <AnnouncementComponent
          handleInnerFormChange={handleInnerFormChange}
          handleFormSubmit={handleFormSubmit}
          selectedAnnouncement={selectedAnnouncement}
          announcementType={libraryData?.result?.AnnouncementType}
          organizationUnits={organizationUnitsLists?.result?.items}
          handleFormItemChange={handleFormItemChange}
          mediaFiles={mediaFiles}
          handleInnerFormItemChange={handleInnerFormItemChange}
          id={parmas?.id}
        />
      }
    </>
  )

}

export default AnnouncementContainer;